import { colors, TableBody, TableCell, TableHeader, TableHeading, TableRow } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';
import StatusTag from '../../StatusTag';

export const StatusTagStyled = styled(StatusTag)`
  margin: 0;
`;

export const TableWrapperStyled = styled.div`
  border: 0.1rem solid ${colors.neutral[300]};
  border-radius: 1rem;
  margin-top: 2rem;
  margin-bottom: 5rem;
  overflow: hidden;
`;

export const TableHeaderStyled = styled(TableHeader)`
  box-sizing: border-box;
`;

export const TableHeadingStyled = styled(TableHeading)`
  width: 5rem;
  padding: 1.6rem 1rem;
  background-color: ${TABLE_HEADER_BG_COLOR};

  &:first-child {
    padding-left: 2.4rem;
  }

  &:last-child {
    padding-right: 2.4rem;
  }
`;

export const TableBodyStyled = styled(TableBody)`
  box-sizing: border-box;
`;

export const TableBodyRowStyled = styled(TableRow)`
  border-bottom: 0.1rem solid ${colors.neutral[300]};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const TableCellStyled = styled(TableCell)`
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${colors.neutral[900]};
  letter-spacing: 0.02rem;
  padding: 1.6rem 1rem;

  &:first-child {
    padding-left: 2.4rem;
  }

  &:last-child {
    padding-right: 2.4rem;
  }
`;
